// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Tt81","colMin":"styles_colMin__3AO8v"};